import { Button, Alert } from 'reactstrap';
import {
  useTranslator,
  UserFlagIdentifierType,
  useToast,
  withMobileAppMode,
  callNativeMobileApp,
  useAppContext,
} from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';

const DayPlanReadyAlert = ({ setUserFlagData, dietPlanIntroSeen, mobileAppMode }) => {
  const { t } = useTranslator();
  const { toastError } = useToast();
  const navigate = useNavigate();
  const {
    consts: { FIRST_DIET_SETTINGS_STEP_SLUG },
  } = useAppContext();

  const setIntroSeen = async () => {
    try {
      await setUserFlagData.setUserFlag(UserFlagIdentifierType.DIET_PLAN_INTRO_SEEN);
    } catch (err) {
      toastError();
      throw err;
    }
  };

  const handleConfirmBtn = () => {
    setIntroSeen();
  };

  const handleChangeSettingsBtn = () => {
    try {
      setIntroSeen();

      if (mobileAppMode) {
        callNativeMobileApp({
          action: 'open_modal',
          payload: {
            path: `/diet-settings/all/${FIRST_DIET_SETTINGS_STEP_SLUG}`,
            modal_variant: 'always_close_btn',
          },
        });
      } else {
        navigate(`/diet-settings/all/${FIRST_DIET_SETTINGS_STEP_SLUG}`);
      }
    } catch (err) {
      toastError();
      throw err;
    }
  };

  if (dietPlanIntroSeen === null) {
    return (
      <Alert color="info" fade={false}>
        <p className="small mb-l">{t('mealPlan.menuReady.notification.content')}</p>
        <div className="text-center">
          <Button color="primary" size="sm" className="me-l" onClick={handleConfirmBtn}>
            {t('mealPlan.menuReady.notification.confirmButton')}
          </Button>
          <Button color="link" size="sm" onClick={handleChangeSettingsBtn}>
            <span className="semi-bold">
              {t('mealPlan.menuReady.notification.changeSettingsButton')}
            </span>
          </Button>
        </div>
      </Alert>
    );
  }

  return '';
};

export default withMobileAppMode(DayPlanReadyAlert);
